<template>
  <div class="terms checkbox">
    <input
      id="terms-and-cond"
      class="terms-and-cond"
      :class="{ selected: termsAndCondState }"
      type="checkbox"
      @click="toggleTermsAndCondState"
      name="terms-and-cond"
      :value="termsAndCondState"
      :checked="termsAndCondState"
    />
    <span class="checkmark" @click="toggleTermsAndCondState"></span>
    <label class="shopping-cart__sidebar-label" v-html="$t('message.privacy_policy')" for="terms-and-cond"/>
  </div>
</template>

<script>
export default {
  name: 'terms-and-conditions',
  props: {
    termsAndCondState: {
      type: Boolean,
      required: true
    },
    addTermsErrorClass: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleTermsAndCondState() {
      this.$emit('toggleTermsAndCondState');
    },
  },
  computed: {
    urlTos() {
      return process.env.VUE_APP_WK_FRONT_END_URL + "/" + this.$i18n.locale + "/termsandconditions";
    },
    urlPrivacy() {
      return process.env.VUE_APP_WK_FRONT_END_URL + "/" + this.$i18n.locale + "/privacy";
    },
    showTermsError() {
      if(this.addTermsErrorClass && !this.termsAndCondState) return true;
    },
  }
}
</script>